import { ACTIONS, MODES, applyAction, createNewGame } from '../engine';
import type { Action, GameState } from '../engine';

export const initialEngineState: GameState = createNewGame(MODES.TWO_PLAYER, 'default-seed');

export function gameReducer(state: GameState | undefined, action: Action): GameState {
  return applyAction(state, action);
}

export { ACTIONS, MODES };
